import React from "react";
import Body from "./Body";

const MaterialAndResources = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default MaterialAndResources;
